import { useDispatch } from 'react-redux';
import { Dispatch } from 'redux';
import { ElementAction } from '../../elements/elementAction';
import { ContentPlanRootState as S } from '../../elements/contentPlan/store';
import { Functions } from '../../types/types';
import { toggleShowHomeWorkspaceModal } from '../ContentPlanning/contentPlanningReducer';
import { Workspace } from '../../types';
import { loadUserSettings } from '../ContentPlanning/contentPlanningActions';
import { AppRefId } from '../../utils/constants';

const setHomeWorkspace =
  (homeWorkspaceId: string): ElementAction<Functions, S> =>
  async (dispatch, getState, { getAPI }) => {
    const { upsertUserSettings } = getAPI();
    await upsertUserSettings({
      refId: AppRefId,
      value: { homeWorkspaceId }
    }).finally(() => {
      dispatch(loadUserSettings());
    });
  };

export const useActions = () => {
  const dispatch: Dispatch<any> = useDispatch();
  return {
    openModal: () => dispatch(toggleShowHomeWorkspaceModal(true)),
    closeModal: () => dispatch(toggleShowHomeWorkspaceModal(false)),
    setHomeWorkspace: async (w: Workspace) =>
      dispatch(setHomeWorkspace(w.props.refId))
  };
};
